import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { DxChartComponent, DxPivotGridComponent } from "devextreme-angular";
import { DxiSeriesComponent } from "devextreme-angular/ui/nested";
import { exportWidgets } from 'devextreme/viz/export';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { O2ReportFiltersComponent } from "../o2-report-filters.component";

@Component({
  selector: 'app-o2-portal-asu-awards-by-application',
  templateUrl: './o2-portal-asu-awards-by-application.component.html',
  styleUrls: ['./o2-portal-asu-awards-by-application.component.scss']
})
export class O2PortalAsuAwardsByApplicationComponent implements AfterViewInit {

  isLoadPanelVisible: boolean = false;
  totalGaseousOxygen = 0;
  totalGaseousOxygenText = "";
  o2PortalAwardsByApplicationData: any;
  o2PortalAwardsByApplicationPieChartData: any;
  o2PortalAwardsByApplicationBarChartData: any;

  pivotGridApplicationAndCompititorDataSource: any;
  pivotGridApplicationAndRegionDataSource: any;
  resolveOverlappingTypes = ['shift', 'hide', 'none'];
  colors: Map<string, string>;
  fromDate: any;
  toDate: any;
  @ViewChild(O2ReportFiltersComponent) reportFilter; 
  @ViewChild(DxChartComponent, { static: false }) dxChart: DxChartComponent;
  @ViewChild(DxiSeriesComponent, { static: false }) dxPieChart: DxChartComponent;
  @ViewChild('VolumeAnalysisByApplicationAndCompetitor', { static: false }) applicationAndCompititorGrid: DxPivotGridComponent;
  @ViewChild('VolumeAnalysisByApplicationAndRegion', { static: false }) applicationAndRegionGrid: DxPivotGridComponent;

  constructor() {
    this.customizeLabel = this.customizeLabel.bind(this);
    this.colors = new Map<string, string>();
  }

  ngAfterViewInit() {
    this.dxChart.instance.render();    
  }

  getO2PortalAwardsByApplication(o2PortalAwardsData) {
    this.o2PortalAwardsByApplicationData = o2PortalAwardsData;
    this.isLoadPanelVisible = false;
    this.fromDate = this.reportFilter.fromDate.getFullYear();
    this.toDate = this.reportFilter.toDate.getFullYear();
    this.colors.clear();
    this.setDataSources();
  }
  setDataSources() {

    this.totalGaseousOxygen = 0;
    // PieChart
    this.o2PortalAwardsByApplicationData.sort((a, b) => { return a.application.localeCompare(b.application) });
    let allArrayData = this.o2PortalAwardsByApplicationData.map(item => {
      this.totalGaseousOxygen = this.totalGaseousOxygen + item.totalOxygen;
      return item;
    });
    this.totalGaseousOxygenText = this.getGaseousOxygenText();
    //let allArrayData = [... this.o2PortalAwardsByApplicationData].map(item => ({ ...item }));
    allArrayData = allArrayData.reduce((acc, item) => {
      let accItem = acc.find(ai => ai.application === item.application);
      if (accItem) {
        accItem.gaseousOxygen = Math.round(accItem.gaseousOxygen + item.gaseousOxygen);
      } else {
        acc.push(item)
      }
      return acc;
    }, []);

    let totalCountArray = [...allArrayData].map(item => ({ ...item }));
    const total = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.gaseousOxygen), 0);

    this.o2PortalAwardsByApplicationPieChartData = allArrayData.map((item, index) => {
      let cumulativeCount = item.gaseousOxygen;
      return {
        application: item.application,
        cumulativePercent: Math.round(cumulativeCount * 100 / total),
      };
    });

    // Bar Chart1
    this.o2PortalAwardsByApplicationData.sort((a, b) => { return a.application.localeCompare(b.application) || (a.awardYear - b.awardYear) });

    this.o2PortalAwardsByApplicationBarChartData = [... this.o2PortalAwardsByApplicationData].map(item => ({ ...item }));
    this.o2PortalAwardsByApplicationBarChartData.sort((a, b) => {
      if (a.awardYear > b.awardYear) {
        return 1;
      }

      if (a.awardYear < b.awardYear) {
        return -1;
      }

      return 0;
    });
    this.o2PortalAwardsByApplicationBarChartData = this.o2PortalAwardsByApplicationBarChartData.reduce((accm, item) => {

      let accItem = accm.find(ai => ai.application === item.application && ai.awardYear === item.awardYear)

      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen);
       // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        accm.push(item)
      }

      return accm;
    }, []);

    this.pivotGridApplicationAndCompititorDataSource = {
      fields: [{
        caption: 'TopCompetitors',
        width: 120,
        dataField: 'topCompetitors',
        area: 'row',
      }, {
        dataField: 'application',
        area: 'column',
      }, {
        groupName: 'application',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByApplicationData
    }

    this.pivotGridApplicationAndRegionDataSource = {
      fields: [{
        caption: 'Region',
        width: 120,
        dataField: 'lasuregions',
        area: 'row',
      }, {
        dataField: 'application',
        area: 'column',
      }, {
        groupName: 'application',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByApplicationData
    }
  }
  getGaseousOxygenText(){
    return this.totalGaseousOxygen.toLocaleString('en-IN') + ' mtpd';
  }
  onCellPrepared(e) {
    if (e.area === "data" && e.cell.text === "") {
      e.cellElement.textContent = "0";
    }
  }
  exportCharts() {
    const pieChartInstance = this.dxPieChart.instance;
    const dxChartInstance = this.dxChart.instance;

    exportWidgets([[pieChartInstance, dxChartInstance]], {
      fileName: "ASUAwards_ByApplication_ChartReport",
      format: "PNG"
    });
  }
  exportExcel(e) {
    const context = this;
    const workbook = new Workbook();
    const regwb = workbook.addWorksheet('Application And Competitor');
    const appwb = workbook.addWorksheet('Application And Region');

    exportPivotGrid({
      worksheet: regwb,
      component: context.applicationAndCompititorGrid.instance,

    }).then(() => {
      exportPivotGrid({
        worksheet: appwb,
        component: context.applicationAndRegionGrid.instance,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASU_Awards_By_Application.xlsx');
        });
      })
    });
  }
  customizeLabel(arg) {
    if (!this.colors.has(arg.argumentText)) {
      this.colors.set(arg.argumentText, arg.point.getColor());
    }
    return `${arg.argumentText} (${arg.percentText})`;
  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.seriesName} : ${arg.valueText}` + ' mtpd',
    };
  }

  customizePoint = (arg: any) => {
    if (this.colors.has(arg.data.application)) {
      return { color: this.colors.get(arg.data.application), hoverStyle: { color: this.colors.get(arg.data.application) } };
    }
  }
}
